<template>
    <div class="">
    <nav class="navbar bg-body-tertiary navbar-expand-md ">
    <Alert v-if="!alert"></Alert>
    <div v-if="showInstallPrompt" class="install-popup">
      <div class="popup-content">
        <p>Install this app on your home screen for a better experience!</p>
        <div class="popup-buttons">
          <button @click="addToHomeScreen">Add to Home Screen</button>
          <button @click="dismissPrompt">Dismiss</button>
        </div>
      </div>
    </div>
    <div class="container">
      <router-link class="navbar-brand " to="/">
        <a href=""><img src="/static/favicon/favicon-32x32.png"></a>
          MegaBull
        <span class="subtitle" >Your Trading Playground </span>
      </router-link>
        <button type="button" class="navbar-toggler  ms-auto " :class="{ 'no-hamburger': isAndroid}" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle Navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class=" my-2 my-lg-0 virtualMoneySize">
          <span  >Available Virtual Money:</span><span> &#8377;  {{ $store.state.user.virtualMoneyLeft? $store.state.user.virtualMoneyLeft.toLocaleString('en-IN') : 0}} <i  @click="reload" class="bi bi-arrow-clockwise"></i></span>
      </div>
    <div >
      <ul class="nav nav-underline collapse navbar-collapse " id="navbarCollapse">
        <li class="nav-item">
          <router-link class="nav-link d-flex d-md-none"  active-class="active" to="/mw">MarketWatch</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link "  active-class="active" to="/orders">Orders</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link"  active-class="active" to="/holdings">Holdings</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link "  active-class="active" to="/positions">Positions</router-link>
        </li>
        <li class="nav-item">
          <!-- <router-link class="nav-link"  active-class="active" to="/report">Reports</router-link> -->
              <a class="nav-link  dropdown-toggle pointer disabled"  data-bs-toggle="dropdown" id="dropdownMenuButton1" aria-expanded="false">Reports</a>
          <div  class="dropdown-menu " aria-labelledby="dropdownMenuButton1">
            <router-link class="dropdown-item " to="/report" @click="Modal = true">Monthly Report</router-link>
            <router-link class="dropdown-item " to="/fundsreport" @click="Modal = true">Funds Report</router-link>
          </div >
        </li>
        <li class="nav-item">
          <a class="nav-link  dropdown-toggle pointer disabled"  data-bs-toggle="dropdown" id="dropdownMenuButton1" aria-expanded="false">Profile</a>
          <div  class="dropdown-menu " aria-labelledby="dropdownMenuButton1">
            <router-link class="dropdown-item " to="/profile" @click="Modal = true">Profile</router-link>
            <a class="dropdown-item pointer" @click=" $store.commit('setVirtualMoney',true) ">Set Virtual Money</a>
            <a class="dropdown-item pointer" @click=" $store.commit('setClearHistory',true) ">Clear History</a>
            <a class="dropdown-item pointer" @click=" $store.commit('setFeedback',true); ">Feedback</a>
            <!-- <router-link class="dropdown-item " to="/positions">Broker Settings</router-link> -->
            <a class="dropdown-item pointer" @click="logout">Logout</a>
          </div >
        </li>
        <li class="nav-item "  @click="expandFun()">
          <i class="bi bi-bell nav-link notification dropdown-container"  ></i>
          <span class="badge" v-if=" $store.state.user.notificationCount > 0">{{ $store.state.user.notificationCount}}</span>
        </li>
      </ul>
      <div class="notification-overlay" v-if="expand" @click="expand = false"></div>
      <div class="dropdown-content" id="dropdownMessages" v-bind:class="{'show' : expand}">
        <div class="notification-header">
          <span>Notifications</span>
          <button type="button" class="btn-close" @click="expand = false" aria-label="Close"></button>
        </div>
        <div class="message"  v-for="(item, index) in notification" v-bind:key="index">
          {{item.message}}
          <p class="message-bottom" >{{ getDateTime(item.createdTimestamp) }}</p>
        </div>
        <div class="message" v-if="notification.length === 0">
          No notifications
        </div>
      </div>
    </div>
    </div>
    </nav>
    <SetVirtualMoney v-if = "$store.state.setVirtualMoney"></SetVirtualMoney>
    <ClearHistory v-if = "$store.state.clearHistory"></ClearHistory>
    <div v-if = "$store.state.feedback" class="modal-overlay" @click.self="$store.commit('setFeedback',false); errorMsg2 ='';">
        <div class="modal-container">
            <div class="modal-content w-60">
                <div class="modal-header">
                    <h5 class="modal-title" id="otpModalLabel">Feedback Form</h5>
                    <button type="button" class="btn-close" @click=" $store.commit('setFeedback',false);  errorMsg2 =''; "  aria-label="Close"></button>
                </div>
                <div class="modal-body ">
                    <form class="" onsubmit="return false;">
                        <div class="mb-3">
                                <div class="form-group">
                                    <label for="monthSelect">Select Subject</label>
                                    <select id="monthSelect" class="form-select" v-model="subject">
                                        <option value="LOGIN">LOGIN</option>
                                        <option value="REPORTS">REPORTS</option>
                                        <option value="GENERAL">GENERAL</option>
                                        <option value="PROFILE">PROFILE</option>
                                        <option value="ORDER">ORDER</option>
                                        <option value="POSITION">POSITION</option>
                                        <option value="FUNDS">FUNDS</option>
                                        <option value="MARGIN">MARGIN</option>
                                    </select>
                                </div>
                        </div>
                        <div class="mb-3">
                                <textarea id="story" style="width:100%" class="form-label" name="story" rows="5" cols="33" v-model="description" placeholder="Description" required>
                                  </textarea>
                        </div>
                        <button  class="btn btn-primary w-100" @click="feedback" >Submit</button>
                        <br /> <br />
                            <p class="form-label" style="color:red;" v-if = "errorMsg2!='Thank You for Feedback, We will be reaching out to you via email shortly to discuss this matter in more detail and ensure that all your concerns are addressed .'">{{ errorMsg2 }}</p>
                            <p class="form-label" style="color:green;" v-if = "errorMsg2 == 'Thank You for Feedback, We will be reaching out to you via email shortly to discuss this matter in more detail and ensure that all your concerns are addressed .'">{{ errorMsg2 }}</p>
                    </form>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { getNotification, getMyScripts, getPositions, getHoldings, getOrders, feedback, track } from '@/service/restService'
import SetVirtualMoney from '@/components/profile/SetVirtualMoney.vue'
import ClearHistory from '@/components/profile/ClearHistory.vue'
import Alert from '@/components/profile/Alert'
export default {
  name: 'NavBar',
  components: {
    Alert,
    SetVirtualMoney,
    ClearHistory
  },
  data () {
    return {
      expand: false,
      notification: {},
      socket: null,
      timer: null,
      Modal: null,
      errorMsg2: '',
      subject: '',
      description: '',
      alert: false,
      deferredPrompt: null,
      showInstallPrompt: false, // To control the visibility of an "Install" button
      isApp: false,
      isAndroid: false
    }
  },
  methods: {
    reload () {
      location.reload()
    },
    handleAppResume () {
      if (this.socket.readyState !== 1) {
        this.connectSocket()
      }
    },
    addToHomeScreen () {
      var obj = {'type': 'APP_INSTALL', value: '1'}
      track(obj).then((response) => {
      })
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt() // Show the native install prompt
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt')
          } else {
            console.log('User dismissed the A2HS prompt')
          }
          this.deferredPrompt = null // Reset the event
          this.showInstallPrompt = false // Hide the popup
        })
      }
    },
    dismissPrompt () {
      this.showInstallPrompt = false // Hide the popup
    },
    logout: function () {
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('token')
      this.$router.push('/signin')
    },
    expandFun: function () {
      if (!this.expand) {
        this.getNotification()
      }
      this.expand = !this.expand
    },
    getNotification: function () {
      getNotification().then((response) => {
        this.notification = response.data
        this.$store.commit('updateUserNotiCount')
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    getPositions: function () {
      getPositions().then((response) => {
        this.$store.commit('updatePosition', response.data)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    feedback: function () {
      if (!this.subject) {
        this.errorMsg2 = 'Please select subject.'
        return
      }
      if (!this.description) {
        this.errorMsg2 = 'Please enter description.'
        return
      }
      var obj = { subject: this.subject, description: this.description }
      this.errorMsg2 = ''
      feedback(obj).then((response) => {
        this.errorMsg2 = 'Thank You for Feedback, We will be reaching out to you via email shortly to discuss this matter in more detail and ensure that all your concerns are addressed .'
        this.subject = ''
        this.description = ''
      }).catch((error) => {
        this.errorMsg2 = error.response.data.message[0]
      })
    },
    getHoldings: function () {
      getHoldings().then((response) => {
        this.$store.commit('updateHolding', response.data)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    getOrders: function () {
      getOrders().then((response) => {
        this.$store.commit('updateExecutedOrder', response.data.executed)
        this.$store.commit('updateOpenOrder', response.data.open)
        this.$store.commit('disableOrderFirstTime')
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    connectSocket: function () {
      var token = localStorage.getItem('token')
      this.socket = new WebSocket('wss://socket.megabull.in?id=' + token)

      this.socket.onmessage = (event) => {
        var obj = JSON.parse(event.data)
        if (obj.TYPE && obj.TYPE === 'ORDER_UPDATE') {
          this.getPositions()
          this.getOrders()
          this.getHoldings()
          this.getUserView()
          if (obj.ALERT_TYPE === 'SUCCESS') {
            this.$store.commit('addToast', {
              title: 'Success!',
              type: 'success',
              message: obj.MSG
            })
          }
          if (obj.ALERT_TYPE === 'FAILURE') {
            this.$store.commit('addToast', {
              title: 'Failure!',
              type: 'error',
              message: obj.MSG
            })
          }
        } else {
          this.$store.commit('updateTick', obj)
        }
      }

      this.socket.onopen = () => {
        clearInterval(this.timer)
        getMyScripts().then((response) => {
          this.$store.commit('updateMyScripts', response.data)
          var jsonObj = {
            'type': 'SUBSCRIBE',
            'data': this.$store.state.myScripts
          }
          this.socket.send(JSON.stringify(jsonObj))
        }).catch((error) => {
          this.$store.commit('addToast', {
            title: 'Failure!',
            type: 'error',
            message: error.response.data.message[0]
          })
        })
      }

      this.socket.onclose = () => {
        this.startReconnect()
      }

      this.socket.onerror = (error) => console.error('ERROR:', error)
    },
    startReconnect: function () {
      this.timer = setTimeout(() => {
        if (this.socket.readyState !== 1) {
          this.connectSocket()
        }
      }, 7000)
    },
    watcher: function () {
      const self = this
      this.$store.watch(
        function (state) {
          return state.myScripts
        },
        function (val) {
          var jsonObj = {
            'type': 'SUBSCRIBE',
            'data': val
          }
          self.socket.send(JSON.stringify(jsonObj))
        },
        {
          deep: true // add this if u need to watch object properties change etc.
        }
      )
    }
  },
  created () {
    if (this.$store.state.userFirstTimeFlag) {
      this.connectSocket()
      this.watcher()
      this.getUserView()
      this.$store.commit('disableUserFirstTime')
    }
    this.alert = sessionStorage.getItem('alert')
    if (this.isWebView() && this.getVersion() >= 4) {
      this.isAndroid = true
    }
  },
  mounted () {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault() // Prevent the default mini-infobar from showing
      this.deferredPrompt = e // Save the event for later use
      this.showInstallPrompt = true // Show the "Install" button
    })

    this.isApp = this.isWebView()
    if (this.isApp) {
      window.addEventListener('appResumed', this.handleAppResume)

      // Optional: Expose a global function for Android to call
      window.onAppResume = this.handleAppResume
    }
  },
  beforeDestroy () {
    // Clean up event listener
    if (this.isApp) {
      window.removeEventListener('appResumed', this.handleAppResume)
    }
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: var(--bs-body-color);
}

.subtitle {
  text-align: left;
  font-size: 12px;

}
.notification{
  color: var(--bs-body-color);
  margin-left: -20px;
  text-decoration: none;
  position: relative;
  display: inline-block;
  border-radius: 2px;
}
.badge {
  position: absolute;
  border-radius: 60%;
  background: var(--bs-primary);
  color: white;
}
.virtualMoneySize {
font-size: 13px;
}
@media all  {
  .navbar .nav-item .dropdown-menu{ display: none; }
  .navbar .nav-item:hover .dropdown-menu{ display: block; }
  .navbar .nav-item .dropdown-menu{ margin-top:0; }
}
.navbar-toggler { margin: 0 auto; }

.dropdown-content {
  display: none;
  position: fixed;
  background-color: var(--bs-body-bg);
  width: 320px;
  max-width: 90vw;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 1050;
  top: 60px;
  right: 20px;
  border: 1px solid var(--bs-border-color);
  border-radius: 10px;
}

.dropdown-content .message {
  color: var(--bs-body-color);
  padding: 12px 15px;
  text-decoration: none;
  display: block;
  border-bottom: 1px solid var(--bs-border-color);
}

.dropdown-content .message:last-child {
  border-bottom: none;
}

.dropdown-content .message:hover {
  background-color: var(--bs-tertiary-bg);
}

.show {
  display: block;
}
.pointer {cursor: pointer;}
.dropdown-container {
  position: relative;
  display: inline-block;
}

/* Mobile notification dropdown */
@media (max-width: 768px) {
  .dropdown-content {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    max-height: 60vh;
    border-radius: 15px 15px 0 0;
    border-bottom: none;
  }
}

.notification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid var(--bs-border-color);
  font-weight: 600;
  background-color: var(--bs-body-bg);
  position: sticky;
  top: 0;
  border-radius: 10px 10px 0 0;
}

.message-bottom{
font-size:10px
}
a.disabled {
  pointer-events: none;
  opacity: 1;
  color: var(--bs-body-color);
}
/* Style your popup/banner */
.install-popup {
  position: fixed;
  bottom: 20px; /* Position it at the bottom */
  left: 50%;
  transform: translateX(-50%); /* Center it horizontally */
  background-color: #000000; /* Soft teal background color */
  color: white;
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 480px; /* Max width for desktop */
  z-index: 1000; /* Make sure it is above other elements */
  text-align: left; /* Align text to the left */
}

/* Content within the popup */
.popup-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

/* Popup buttons container */
.popup-buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-start; /* Align buttons to the left */
  width: 100%;
  margin-top: 10px;
}

.popup-buttons button {
  background: white;
  color: #070707; /* Matching button color with the popup background */
  border: none;
  padding: 12px 18px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-right: 15px; /* Space between buttons */
  flex-shrink: 0;
  width: auto; /* Ensure buttons don't stretch */
}

.popup-buttons button:hover {
  background: #e0f2f1; /* Light hover effect */
}

/* Responsive styles for smaller screens */
@media (max-width: 600px) {
  .install-popup {
    width: 90%;
    bottom: 10px;
  }

  .popup-buttons {
    flex-direction: column; /* Stack buttons vertically on mobile */
    margin-top: 10px;
  }

  .popup-buttons button {
    width: 100%;
    margin-right: 0; /* Remove space between buttons */
    margin-bottom: 10px;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background-color: var(--bs-body-bg);
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  padding: 15px;
}

.modal-content {
  border: none;
  background-color: var(--bs-body-bg);
}
.no-hamburger {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/NavBar.vue